export enum ObjectKeys {
    AUDIT = 'AudAudit',
    ADDRESS = 'Address',
    AUDITITEM = 'AudAuditItem',
    BIBCATEGORY = 'AudBibCategory',
    BIBMEAUSRE = 'AudBibMeasure',
    BIBQUESTION = 'AudBibQuestion',
    BIBRESPONSE = 'AudBibResponse',
    LIBRARY = 'AudLibrary',
    MEAUSRE = 'AudMeasure',
    VARIANT = 'AudVariant',
    Person = 'Person',
    VARIANTITEM = 'AudVariantItem',
    TASK = 'Task',
    PICKLIST = 'Picklist',
    PICKLISTITEM = 'PicklistItem',
    COMMENT = 'Comment',
    BOX = 'Box',
    BOXDETAIL = 'BoxDetail',
  }